<template>
	<div class="row">
		<div class="col-md-5">
			<div class="card">
				<div class="card-header bg-dark">
					<h3 class="mb-0 text-white">ตั้งค่าระบบแนะนำเพื่อน</h3>
				</div>
				<div class="card-body">
					<form @submit.prevent="saveConfig">
						<div class="row">
							<div class="col-md-6">
								<base-input
									label="จำนวนที่ได้รับ"
									placeholder="จำนวนที่ได้รับ"
									v-model="setting.amount"
								/>
							</div>
							<div class="col-md-6">
								<base-input
									label="จำนวนที่ได้รับสูงสุด"
									placeholder="จำนวนที่ได้รับสูงสุด"
									v-model.number="setting.max"
								/>
							</div>
						</div>

						<base-input
							label="จำนวนเติมขั้นต่ำ"
							placeholder="จำนวนเติมขั้นต่ำ"
							v-model.number="setting.min"
						/>

						<div class="row align-items-center">
							<div class="col-6">
								<base-checkbox v-model="setting.withdrawToGame">
									โยกเงินแนะนำเพื่อนเข้าเกม
								</base-checkbox>
							</div>
							<div class="col-6">
								<base-input
									label="เทิร์น (เท่า)"
									placeholder="เทิร์น (เท่า)"
									v-model.number="setting.toGameTurn"
									v-if="setting.withdrawToGame"
								/>
							</div>
						</div>

						<div class="mt-3">
							<small class="d-block text-danger mb-2">
								* ระบบจะบังคับผู้ถูกแนะนำรับ
								<b>"โบนัสสมัครสมาชิกใหม่"</b> โดยอัตโนมัติเมื่อเติมเงิน
							</small>
							<base-button native-type="submit" type="default" :disabled="loading">
								บันทึกข้อมูล
							</base-button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AffiliateService from '../services/affiliate.service'

export default {
	data() {
		return {
			loading: false,
			setting: {},
		}
	},
	methods: {
		saveConfig() {
			this.loading = true
			AffiliateService.saveAffiliateSetting(this.setting)
				.then(({ message }) => {
					this.$notify({ type: 'success', message: message })
				})
				.catch(({ message }) => {
					this.$notify({ type: 'danger', message: message })
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	created() {
		AffiliateService.getAffiliateSetting().then((res) => {
			this.setting = res
		})
	},
}
</script>
